import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import agreeEdit from './agreeEdit';
import { getAgreement } from 'api/settings';
import agreePreview from './agreePreview';
import { agreementSave } from 'api/settings';
export default {
  components: {
    agreeEdit: agreeEdit,
    agreePreview: agreePreview
  },
  data: function data() {
    return {
      agreeContent: {
        type: '',
        title: this.$t('i18n.cc2205ac932a4b34b31ec3ef16fbd452'),
        created_at: '',
        // 创建时间
        content: '' // 内容
      },

      loading: false,
      isRelease: true,
      isEdit: false // 是否编辑
    };
  },
  created: function created() {
    this.agreementGet();
  },
  methods: {
    // Mobile 预览
    handlePreview: function handlePreview() {
      this.$refs.pre.visible = true;
    },
    // handleEdit() {
    //   this.isEdit = true
    // },
    // 获取协议
    agreementGet: function agreementGet() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              getAgreement().then(function (_ref) {
                var data = _ref.data;
                var file = data.file_url ? [{
                  object_url: data.file_url,
                  name: data.file_url
                }] : [];
                data.file = file;
                _this.agreeContent = data;
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 存储隐私协议
    handleSave: function handleSave() {
      var _this2 = this;
      this.isRelease = false;
      var edit = this.$refs.edit;
      edit.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.isEdit = false;
          _this2.agreeContent.file_url = edit.form.file_url;
          _this2.agreeContent.file = edit.form.file_url ? [{
            object_url: edit.form.file_url,
            name: edit.form.file_url
          }] : [];
          _this2.agreeContent.content = edit.form.content;
          _this2.agreeContent.p_type = edit.form.p_type;
        }
      });
    },
    handleFile: function handleFile(url) {
      window.open(url.object_url);
    },
    // 存储隐私协议
    handleRelease: function handleRelease() {
      var _this3 = this;
      this.$confirm(this.$t('i18n.bc89546a8ec545b6a40ed44a12356aa6'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _this3.isRelease = true;
        _this3.loading = true;
        agreementSave(_this3.agreeContent).then(function () {
          _this3.$message({
            message: _this3.$t('i18n.0d05a02a8cbd433687acf90829b35fee'),
            type: 'success'
          });
          _this3.agreementGet();
        }).finally(function () {
          return _this3.loading = false;
        });
      });
    }
  }
};